import { render, staticRenderFns } from "./RunningCampaigns.vue?vue&type=template&id=f8f98f28&scoped=true"
import script from "./RunningCampaigns.vue?vue&type=script&lang=ts"
export * from "./RunningCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./RunningCampaigns.vue?vue&type=style&index=0&id=f8f98f28&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f98f28",
  null
  
)

export default component.exports